import React, { type MouseEventHandler } from "react";
import { twMerge } from "tailwind-merge";
import { SupDepositAlt } from "@repo/core-ui";

import styles from "./DepositButton.module.css";

interface DepositButtonProps {
  className?: string;
  disabled?: boolean;
  handleClick?: MouseEventHandler<HTMLButtonElement>;
}

export function DepositButton({ disabled = false, className, handleClick }: DepositButtonProps) {
  return (
    <div
      className={twMerge(
        "relative h-10 w-24 overflow-hidden rounded-br-2xl border-0.5 border-primary-500 bg-primary-100",
        styles.removeButton,
        className,
        disabled ? "cursor-not-allowed text-neutral-500 [&>button]:bg-neutral-200" : "text-primary-800 [&>button]:bg-primary-25",
        !disabled && "[&:hover>button]:bg-primary-75"
      )}
    >
      <button
        disabled={disabled}
        className="absolute flex h-10 w-24 items-center justify-center gap-1 bg-neutral-50 text-xs leading-4 tracking-[0.5px] transition-all duration-200"
        onClick={handleClick}
      >
        <SupDepositAlt /> DEPOSIT
      </button>
    </div>
  );
}
